import React, { useEffect, useState } from "react";
import styles from "./RadioGroup.module.css";

interface Option {
  id: string;
  label: string;
}

interface RadioGroupProps {
  options: Option[];
  name: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  selectFirstWhenNoValueProvided?: boolean
}

const RadioGroup: React.FC<RadioGroupProps> = ({ options, name, defaultValue, onChange, selectFirstWhenNoValueProvided=true }) => {
  const [selected, setSelected] = useState<string>(defaultValue || (selectFirstWhenNoValueProvided ? options[0]?.id : ''));

  useEffect(() => {
    if (defaultValue) {
      setSelected(defaultValue);
    }
  }, [defaultValue])

  const handleChange = (value: string) => {
    setSelected(value);
    if (onChange) onChange(value);
  };

  return (
    <div className={styles.radioGroup}>
      {options.map((option) => (
        <label key={option.id} className={styles.radioLabel}>
          <input
            type="radio"
            name={name}
            value={option.id}
            checked={selected === option.id}
            onChange={() => handleChange(option.id)}
            className={styles.radioInput}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default RadioGroup;